import React, { PureComponent, Component } from 'react';
import Styles, { disableLongPressBS, moxiVerdigris, noSelect } from '../constants/Styles';

import { getLockProxyHost, setLockProxyHost, setAudioPrimed } from '../constants/Meta';

import Checkbox from './Checkbox';

import Loader from './Loader';
import { DRButton } from './DRControls';
import { getDeliveryType, configureUnit, countForReload, registerRelog, getRelog, clearRelog, getsIdsMoxspotNames, 
  getRobotNames, stashConfig, getStashedConfig, r2h, h2r } from '../vodjs/lib.js';
import { env, removedConfigWaypoints, login } from '../vodjs/settings';
import VersionDisplay from './VersionDisplay';
import WebPicker from './WebPicker';

import Locktube from '../vodjs/Locktube';
import { elasticLogConfig, elasticLogEvent, elasticLogError, netLog, getMachineUid } from '../vodjs/ElasticLog';
import { startErrorHandling } from '../vodjs/ErrorHandling';
import { isMobile, isWideMobile, clearFetch, asyncSetState } from '../vodjs/Utils';
import { PollMgrStartPolling } from '../vodjs/PollMgr';
import Audio from '../constants/Audio';
import { kInfoUnpack } from './KInfo';
import { getConfig } from '../utils/configUtils';

const mobile = isMobile();
const gripperIconSz = mobile ? 24 : 45;

const ROBOT_TYPE = 'Robot';
const NO_ROBOT = 'None';

const UNVERIFIED_TASK_EXEC = "Note: cannot verify that robot's task-executor is running.";

const debugCreds = undefined; //user, password
let skipUnitSelection = false;

const verifyRobotConnection = true; //now needed for lockproxy to figure out pollmost

export default class LogIn extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      userLoggedIn: false,
      username: '',
      password: '',
      unit: '',
      robot: '',
      units: null,
      robots: null,
      userTypes: null,
      unitSubmitted: false,
      isLoading: false,
      showSuccess: false,
      configurationType: undefined,
      tmpDisregardServiceHours: false,
      tubeProxyVerified: false,
    };
    startErrorHandling();

    this.handleDimensionChange = this.handleDimensionChange.bind(this);
    this.state.wideMobile = isWideMobile();
    this.usernameRef = React.createRef();

    let relogData = getRelog(); //if truthy: {data, userAck}
    this.userAck = !!(relogData || {}).userAck;
    this.priorSession = (relogData || {}).data;
    this.nextRelog = this.priorSession || {};

    this.tappableRef = React.createRef();
  }

  handleDimensionChange(event) {
    this.setState({ wideMobile: isWideMobile() });
  }

  //this is to pre-fetch resources that the robot will need when the internet might be bad
  async preloadImages() {
    let preload = [
      require('../assets/images/close-x.png'),
      require('../assets/images/x.png'),
      require('../assets/images/splus_moxi_front_back-closed.png'),
      require('../assets/images/questionMarkInCircle.png'),
      require('../assets/images/blue_gripper.png'),
      require('../assets/images/icon-airdrop.png'),
      require('../assets/images/close_no_fill.png'),
      require('../assets/images/tick_no_fill.png'),
      require('../assets/images/left-select.png'),
      require('../assets/images/right-select.png'),
      require('../assets/images/splus/large/requested.png'),
      require('../assets/images/splus/large/unlocked.png'),
      require('../assets/images/splus/large/filled.png'),
      require('../assets/images/splus/large/locked.png'),
      require('../assets/images/splus/medium/requested.png'),
      require('../assets/images/splus/medium/unlocked.png'),
      require('../assets/images/splus/medium/filled.png'),
      require('../assets/images/splus/medium/locked.png'),
      require('../assets/images/splus/small/requested.png'),
      require('../assets/images/splus/small/unlocked.png'),
      require('../assets/images/splus/small/filled.png'),
      require('../assets/images/splus/small/locked.png'),
      require('../assets/images/welcome_diligent_logo.png'),
      require('../assets/images/moxi-badge-reader.gif'),
      require('../assets/images/moxi-question.png'),
      require('../assets/images/moxi-at-door.png'),
      require('../assets/images/estop-button.png'),
    ];

    let images = [];

    for (var i = 0; i < preload.length; i++) {
      let img = new Image();
      img.src = preload[i];
      images.push(img);
    }

    window.preloadedImages = images;
  }

  componentDidMount() {
    if (debugCreds || this.priorSession) {
      setTimeout(() => this.goToNextPhase(), 200);
    }
    else {
      let siteMbot = getConfig().uiSimServer;
      if (siteMbot) {
        let k = Math.floor(1e10 * Math.random()).toString(16);
        let options = {
          method: 'PUT',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ k, type: 'startup' }),
        };

        const url = new URL('getKInfo', siteMbot);
        clearFetch(url, options, {
          success: async ({ kInfo }) => {
            if (!kInfo) return this.schedulePing(siteMbot);
            let expanded = kInfoUnpack(k, kInfo);
            if (expanded.u && expanded.p) {
              await asyncSetState(this, { kInfo: expanded });
              this.goToNextPhase();
            }
            else {
              this.schedulePing(siteMbot);
            }
          },
          bad: ({ logStr }) => this.schedulePing(siteMbot),
        });
      }
    }

    window.addEventListener('resize', this.handleDimensionChange);
    if (this.usernameRef.current)
      //falsey if this.userAck
      this.usernameRef.current.focus();

    this.preloadImages();
  }

  schedulePing(siteMbot) {
    if (this.unmounting) return;

    let stashedConfig = getStashedConfig();

    this.pingTimeout = setTimeout(() => {
      this.pingTimeout = undefined;
      if (this.unmounting) return;

      let k = Math.floor(1e10 * Math.random()).toString(16);
      let options = {
        method: 'PUT',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ k, type: 'ping', config: stashedConfig, mid: getMachineUid() }),
      };
      const url = new URL('getKInfo', siteMbot);
      clearFetch(url, options, {
        success: async ({ kInfo }) => {
          if (!kInfo) return this.schedulePing(siteMbot);
          let expanded = kInfoUnpack(k, kInfo);
          if (expanded && expanded.u && expanded.p && expanded.config) {
            this.priorSession = this.nextRelog = expanded;
            this.goToNextPhase();
          }
          else {
            this.schedulePing(siteMbot);
          }
        },
        bad: ({ logStr }) => this.schedulePing(siteMbot),
      });
    }, 1000 * 90);
  }

  componentWillUnmount() {
    this.unmounting = true;
    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
      this.pingTimeout = undefined;
    }
    window.removeEventListener('resize', this.handleDimensionChange);
  }

  _handleError(errorString) {
    console.log(errorString);
    this.setState({ error: `${errorString}` });
  }

  async goToNextPhase() {
    if (!this.state.userLoggedIn) {
      //phase 1: user is NOT yet logged in
      const config = getConfig();
      this.setState({ isLoading: true });

      try {
        if (debugCreds) {
          await netLog('login', async () => await login(debugCreds.user, debugCreds.password, debugCreds.noFS));
        }
        else if (this.priorSession) {
          await netLog('login', async () => await login(this.priorSession.u, this.priorSession.p, this.priorSession.noFS));
        }
        else if (this.state.kInfo) {
          await netLog('login', async () => await login(this.state.kInfo.u, this.state.kInfo.p, this.state.kInfo.noFS));
          this.nextRelog = { ...this.nextRelog, u: this.state.kInfo.u, p: this.state.kInfo.p, noFS: this.state.kInfo.noFS };
        }
        else {
          await netLog('login', async () => await login(this.state.username, this.state.password, this.state.noFS));
          this.nextRelog = { ...this.nextRelog, u: this.state.username, p: this.state.password, noFS: !!this.state.noFS };
        }
      }
      catch (e) {
        this.setState({ kInfo: undefined }); //so if user manually logs in, doesn't get extra need for tri-tap
        let msg = 'Error logging in: ' + (e.message || 'generic error');
        this._handleError(msg);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({ isLoading: false, userLoggedIn: true });
      elasticLogEvent({ what: 'loggedIn', msg: `version=${getConfig().version.branch}` });

      try {
        let units = getsIdsMoxspotNames(); //config.argOptions.id.userStrings;
        let robots = getRobotNames(); //config.argOptions.robot.userStrings.filter(r => r != NO_ROBOT);
        // let userTypes = ['Administrator'];  //config.argOptions.user_type.userStrings;  //.concat(ROBOT_TYPE); removing robot mode
        let userTypes = ['Standard', 'Robot'];
        this.setState({
          units,
          robots,
          userTypes,
          unit: units[0],
          robot: NO_ROBOT,
          configurationType: userTypes[0],
          error: removedConfigWaypoints
            ? `Misconfigured, filtered from unit menu: ${removedConfigWaypoints.join(', ')}.`
            : undefined,
        });
      }
      catch (e) {
        this._handleError('Post-login error: ' + (e.message || '(no message)'));
        console.log(e);
      }

      //if reloading as a unit that no longer exists, force human to do login+config
      if (this.priorSession) {
        let isValidUnit = true;
        if (this.priorSession.config.unitCode) {
          let friendlyUnit = r2h(this.priorSession.config.unitCode);
          if (!friendlyUnit) {
            elasticLogError({
              what: 'noReload',
              msg: `Was reloading as non-existent unitCode ${this.priorSession.config.unitCode}`,
            });
            isValidUnit = false;
          }
          else if (friendlyUnit != this.priorSession.config.unit) {
            elasticLogError({
              what: 'retarget',
              msg: `Name for unitCode ${this.priorSession.config.unitCode} changed from ${this.priorSession.config.unit} to ${friendlyUnit}`,
            });
            this.priorSession.config.unit = friendlyUnit;
          }
        }
        else {
          //handle cases prior to persisting of unitCode
          if (this.state.units.indexOf(this.priorSession.config.unit) < 0) {
            elasticLogError({
              what: 'noReload',
              msg: `Was reloading as non-existent unit ${this.priorSession.config.unit}`,
            });
            isValidUnit = false;
          }
        }

        if (!isValidUnit) {
          skipUnitSelection = false;
          this.priorSession = undefined;
          this.userAck = false;
        }
      }

      if (skipUnitSelection) {
        let lockType = undefined,
          lockNames = undefined;
        await configureUnit({ friendly: this.state.unit }, undefined, lockType, lockNames);
        this.setState({ unitSubmitted: true });
        this.props.setUserLoggedIn(true);
        let { unit } = this.state;
        elasticLogConfig({ unit, robot: NO_ROBOT, lockType, lockNames });
      }
      else if (this.priorSession) {
        if (!this.userAck) setTimeout(() => this.goToNextPhase(), 200); //note that audio not primed
      }
      else if (debugCreds) {
        setTimeout(() => this.goToNextPhase(), 200);
      }
      else {
        if (verifyRobotConnection) {
          this.tubeProxyVerifier = Locktube.getTubeProxyVerifier();
          this.checkTubeProxy();
        }
      }
    }
    else {
      //phase 2: user IS logged in

      let robot = this.state.robot;
      let isRobot = this.state.configurationType == ROBOT_TYPE;

      // if(isRobot && verifyRobotConnection && !this.tubeProxyVerifier.getVerified()) {
      //   //when configuring as robot, do not allow login without having reached
      //   //the robot, because we need to know what storage configuration we're handling.
      //   return;
      // }

      let lockType = 'storage_plus',
        lockNames = ['small', 'medium', 'large'];
      // if(isRobot) {
      if (this.tubeProxyVerifier) {
        // let proxyVerifyResult = this.tubeProxyVerifier.getLockType();
        // lockType = proxyVerifyResult.lockType;
        // lockNames = proxyVerifyResult.lockName;
        this.tubeProxyVerifier.stop();
        this.tubeProxyVerifier = undefined;
      }
      // }

      let unit = this.state.unit;

      if (this.priorSession) {
        let config = this.priorSession.config;
        unit = config.unit;
        robot = config.robot;
        lockType = config.lockType;
        lockNames = config.lockNames;

        isRobot = robot != NO_ROBOT;

        setLockProxyHost(this.priorSession.lockProxyHost);
      }

      let stationParams, robotParams;
      if (isRobot) {
        robotParams = { friendly: robot };
      }
      else {
        robot = NO_ROBOT;
        stationParams = { friendly: unit };
      }

      await configureUnit(stationParams, robotParams, lockType, lockNames);
      let unitCode = h2r(unit);
      stashConfig({ unit, unitCode, robot: robot == NO_ROBOT ? undefined : robot, lockType, lockNames });

      // if (this.state.tmpDisregardServiceHours) env.siteConfig.tmpDisregardServiceHours();

      this.setState({ unitSubmitted: true });
      this.props.setUserLoggedIn(true);
      elasticLogConfig({ unit, robot, lockType, lockNames });
      this.nextRelog.config = { unit, unitCode, robot, lockType, lockNames };

      if (this.tubeProxyVerifier) this.tubeProxyVerifier.stop();

      if (isRobot) PollMgrStartPolling();

      this.nextRelog.lockProxyHost = getLockProxyHost();
      registerRelog(this.nextRelog);
      this.nextRelog = undefined;
      clearRelog(); //unpersist

      Audio.init(); //nb: needs to be in thread caused by user action!  //TODO: remove (moot now that routed ios audio path with main)
    }
  }

  checkTubeProxy() {
    if (!this.tubeProxyVerifier) return;

    if (this.tubeProxyVerifier.getVerified()) {
      this.setState({ tubeProxyVerified: true });
      if (this.state.error == UNVERIFIED_TASK_EXEC) this.setState({ error: undefined });
      return;
    }
    else if (this.state.configurationType == ROBOT_TYPE) {
      if (!this.state.error) this._handleError(UNVERIFIED_TASK_EXEC);
    }
    else {
      if (this.state.error == UNVERIFIED_TASK_EXEC) this.setState({ error: undefined });
    }
    setTimeout(() => this.checkTubeProxy(), 500);
  }

  setConfigurationType(itemValue) {
    this.setState({ configurationType: itemValue });
    if (itemValue != ROBOT_TYPE) {
      this.setState({ robot: NO_ROBOT });
    }
    else {
      this.setState({ robot: this.state.robots[0] });
    }
  }

  handleWaitTap(e) {
    let r = this.tappableRef.current.getBoundingClientRect();
    let side = e.clientX < (r.left + r.right) / 2 ? 'L' : 'R';
    this.sides = this.sides || [];
    let now = Date.now();
    this.sides.push({ when: now, side });

    while (this.sides.length > 3) this.sides.shift();
    while (this.sides.length && this.sides[0].when < now - 1000 * 3) this.sides.shift();

    if (this.sides.length == 3) {
      let joined = this.sides.map(({ side }) => side).join('');
      if (joined == 'LRL' || joined == 'RLR') this.setState({ kInfo: undefined });
    }
  }

  makeLoggedInWait() {
    return (
      <div
        ref={this.tappableRef}
        style={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          color: moxiVerdigris,
          fontSize: 60,
          fontStyle: 'italic',
          ...noSelect,
        }}
        onClick={(e) => this.handleWaitTap(e)}
      >
        Diligent Robots
      </div>
    );
  }

  render() {
    if (this.state.kInfo) return this.makeLoggedInWait();

    const titleFont = { fontWeight: 700, fontSize: mobile ? 20 : 30 };
    const robotFont = { ...titleFont };
    const grayedTextColor = '#CCC';

    let textBoxFontSize = mobile ? 16 : 28;
    let textBoxHeight = mobile ? 30 : 40;
    let textBoxWidth = mobile ? 220 : 320;

    if (this.state.configurationType != ROBOT_TYPE) robotFont.color = grayedTextColor;
    let robotDisabledText = { color: grayedTextColor };
    robotDisabledText.fontSize = 'inherit';

    let nameAndPwFlexFlow = this.state.wideMobile ? 'row' : 'column';
    let mwide = this.state.wideMobile;
    let paddingTop = 20;
    let isBotMode = this.state.configurationType == ROBOT_TYPE;

    let background = undefined; //'linear-gradient(0deg, rgba(156,170,238,1) 0%, rgba(148,236,229,1) 100%)';

    let showUnits = !!this.state.units && !this.userAck;
    let userAck = !!this.state.units && this.userAck;
    let ackVerbiage;
    if (userAck && this.priorSession.config) {
      let unit = this.priorSession.config.robot;
      if (!unit || unit == NO_ROBOT) unit = this.priorSession.config.unit;
      ackVerbiage = `Configuring as ${unit}.`;
    }

    //https://cssgradient.io
    return (
      <div
        style={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: `calc(100vh - ${paddingTop}px)`,
          minHeight: 200,
          paddingTop,
          background,
        }}
      >
        <div style={{ flex: 1 }} />

        {!this.state.userLoggedIn && !this.userAck && (
          <form autoCapitalize={'none'} autoComplete={'off'} autoCorrect={'off'} spellCheck={'false'}>
            {/*Diligent Logo*/}
            <img
              id={'diligent_logo'}
              alt={'Diligent Robotics logo'}
              draggable="false"
              src={require('../assets/images/blue_gripper.png')}
              style={{
                position: 'absolute',
                left: 10,
                top: 10,
                width: gripperIconSz,
                height: gripperIconSz,
                ...disableLongPressBS,
              }}
              onClick={() => countForReload({ label: 'Login1' })}
            />

            <div
              style={{ display: 'flex', flexFlow: nameAndPwFlexFlow, alignItems: 'center', justifyContent: 'center' }}
            >
              <div
                style={{
                  ...titleFont,
                  width: '6em',
                  display: 'flex',
                  flexFlow: 'row',
                  marginRight: mwide ? 10 : undefined,
                }}
              >
                User name
              </div>
              <input
                ref={this.usernameRef}
                id={'username'}
                alt={'username field'}
                style={{
                  height: textBoxHeight,
                  borderColor: 'gray',
                  width: textBoxWidth,
                  fontSize: textBoxFontSize,
                  borderRadius: textBoxHeight * 0.5,
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
                onChange={(e) => this.setState({ username: e.target.value })}
                onFocus={() => this.setState({ error: false })}
                autoCapitalize={'none'}
                autoComplete={'off'}
                autoCorrect={'off'}
                spellCheck={'false'}
              />
            </div>

            {/*Password Field*/}
            <div
              style={{
                display: 'flex',
                flexFlow: nameAndPwFlexFlow,
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 20,
              }}
            >
              <div
                style={{
                  ...titleFont,
                  width: '5em',
                  display: 'flex',
                  flexFlow: 'row',
                  marginRight: mwide ? 10 : undefined,
                }}
              >
                Password
              </div>
              <input
                id={'password'}
                alt={'Password field'}
                style={{
                  height: textBoxHeight,
                  borderColor: 'gray',
                  width: textBoxWidth,
                  fontSize: textBoxFontSize,
                  borderRadius: textBoxHeight * 0.5,
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
                type="password"
                onChange={(e) => this.setState({ password: e.target.value })}
                onFocus={() => this.setState({ error: false })}
              />
            </div>
          </form>
        )}

        {!!showUnits && (
          <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginBottom: 20 }}>
            <img
              draggable="false"
              src={require('../assets/images/blue_gripper.png')}
              style={{
                position: 'absolute',
                left: 10,
                top: 10,
                width: gripperIconSz,
                height: gripperIconSz,
                ...disableLongPressBS,
              }}
              id={'diligent_logo'}
              alt={'Diligent Robotics logo'}
              onClick={() => countForReload({ label: 'Login2' })}
            />

            <div id="mode" style={{ ...titleFont, marginRight: 5 }}>
              Mode:
            </div>
            <WebPicker
              id={'mode_select'}
              alt={'Selection drop down for Mode'}
              itemStyle={{ height: 150, textAlign: 'center' }}
              onValueChange={(itemValue, itemIndex) => this.setConfigurationType(itemValue)}
              selectedValue={this.state.configurationType}
              values={this.state.userTypes}
            ></WebPicker>
          </div>
        )}

        {/*Unit Select*/}
        {!!showUnits && !isBotMode && (
          <div id="unit" style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ ...titleFont, marginRight: 5 }}>Unit:</div>
            <WebPicker
              id={'unit_select'}
              alt={'Selection drop down for Unit'}
              itemStyle={{ height: 150, textAlign: 'center' }}
              onValueChange={(itemValue, itemIndex) => this.setState({ unit: itemValue })}
              selectedValue={this.state.unit}
              values={this.state.units}
            ></WebPicker>
          </div>
        )}

        {/*Robot Select*/}
        {!!showUnits && isBotMode && (
          <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ ...robotFont, marginRight: 5 }}>Robot:</div>
            {isBotMode && (
              <WebPicker
                id={'robot_select'}
                alt={'Selection drop down for Robot'}
                itemStyle={{ height: 150, textAlign: 'center' }}
                onValueChange={(itemValue, itemIndex) => this.setState({ robot: itemValue })}
                selectedValue={this.state.robot}
                values={this.state.robots}
              ></WebPicker>
            )}
          </div>
        )}

        {!!ackVerbiage && <div>{ackVerbiage}</div>}

        {!!showUnits && !isBotMode && verifyRobotConnection && (
          <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginBottom: 40 }} />
        )}

        <div
          id="submit"
          style={{ marginTop: 45, display: 'flex', flexFlow: 'column', justifyContent: 'center', alignItems: 'center' }}
        >
          {this.state.error && (
            <div
              style={{
                fontWeight: 800,
                backgroundColor: '#FFAAAA',
                borderRadius: 15,
                padding: 10,
                marginBottom: 35,
                width: '100%',
              }}
            >
              {this.state.error}
            </div>
          )}

          <DRButton
            id="submit"
            alt={'Submission button'}
            action={() => {
              if (this.state.userLoggedIn) {
                setAudioPrimed(); //button is taking us direct into HomeScreen
              }
              this.goToNextPhase(true);
            }}
            phrase={'SUBMIT'}
            fontColor={'black'}
            fillColor={'white'}
            borderColor={'black'}
          />
        </div>

        <div style={{ flex: 1 }} />
        <VersionDisplay />
      </div>
    );
  }
}


